import script from "./Thinking.vue?vue&type=script&setup=true&lang=js"
export * from "./Thinking.vue?vue&type=script&setup=true&lang=js"

import "./Thinking.vue?vue&type=style&index=0&id=600022e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-600022e9"]])

export default __exports__